import React from 'react'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'

const IpiNumberToolTip = () => (
    <CustomToolTip
        type="?"
        info={
            <>
                <p>
                    If you have a Publisher IPI (Interested Party Identifier), enter it here. If not, leave this field
                    blank.
                </p>
                <p>If you&apos;ve established your publisher at a PRO, they will have information about your IPI.</p>
            </>
        }
    />
)

export default IpiNumberToolTip
